import Vue from 'vue'
import Router from 'vue-router'
// 路由重复push
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const routes = [{
        path: '/home',
        name: 'layout',
        component: () => import( /* webpackChunkName: "LayoutIndex" */ '@/pages/layout/index.vue'),
        meta: {},
        children: [{
                path: '/home',
                name: 'home',
                component: () => import( /* webpackChunkName: "home" */ '@/pages/home/index.vue')
            },
            {
                path: '/product',
                name: 'product',
                component: () => import( /* webpackChunkName: "product" */ '@/pages/product/index.vue')
            },
            {
                path: '/report',
                name: 'report',
                component: () => import( /* webpackChunkName: "report" */ '@/pages/report/index.vue')
            }, {
                path: '/company/predict',
                name: 'companyPredict',
                component: () => import( /* webpackChunkName: "companyPredict" */ '@/pages/companyPredict/index.vue')
            },
        ]
    },
    {
        path: '*',
        redirect: '/home'
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import( /* webpackChunkName: "contact" */ '@/pages/contact/index.vue')
    },
    // 研报详情
    {
        path: '/report/detail',
        name: 'Detail',
        component: () => import( /* webpackChunkName: "Detail" */ '@/pages/report/detail.vue'),
    },
    // 产品介绍宏观
    {
        path: '/macro',
        name: 'macro',
        component: () => import( /* webpackChunkName: "Macro" */ '@/pages/introduce/macro.vue'),
    },
    // 产品介绍全口径
    {
        path: '/fullAperture',
        name: 'FullAperture',
        component: () => import( /* webpackChunkName: "FullAperture" */ '@/pages/introduce/fullAperture.vue'),
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录',
        },
        component: () => import( /* webpackChunkName: "login" */ '@/pages/login/index.vue'),
    },
]
const router = new Router({
    routes
})
export default router